/*
  SZW 10/17: "How it's made" turnable stack on three-layer vinyl colour pages (snippets/szw-features.liquid, mode
  'howmade'; styles in assets/szw-features.css). The block renders complete without this file, layers pulled apart.
  This adds: drag on the drawing to turn it (pointer events; touch-action:none on the drawing only, so the page still
  scrolls around it), the "Pull the layers apart / Put the layers together" button, and lift-a-layer from the captions
  (hover on desktop, tap or Enter/Space on any device). Motion follows prefers-reduced-motion through the CSS.
*/
(function () {
  if (customElements.get('szw-howmade')) return;

  var SIDE = 500; // stage width (px) at which the 260px stack is drawn at scale 1

  class SzwHowmade extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this.stage = this.querySelector('.szw-howmade__stage');
      this.stack = this.querySelector('[data-szw-hm-stack]');
      this.open = this.querySelector('[data-szw-hm-open]');
      this.range = this.querySelector('[data-szw-hm-range]');
      if (!this.stage || !this.stack) return;
      this._on = true;
      this.rx = 58; this.rz = -36; this.apart = true; this.pinned = 0; this.drag = null;
      this.slabs = Array.prototype.slice.call(this.querySelectorAll('.szw-hm-slab'));
      this.keys = Array.prototype.slice.call(this.querySelectorAll('.szw-howmade__layer'));
      this.classList.add('is-live');
      var hint = this.querySelector('.szw-howmade__hint');
      if (hint) hint.hidden = false;
      if (this.range) {
        this.open.hidden = false;
        this.range.addEventListener('input', this.onRange.bind(this));
        this.range.addEventListener('change', function () { this.stack.classList.remove('is-sliding'); }.bind(this));
        // start closed, then open by itself the first time it is on screen (reduced motion: stays open)
        var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!still && 'IntersectionObserver' in window) {
          this.setApart(0);
          var io = new IntersectionObserver(function (en) {
            if (!en[0].isIntersecting) return;
            io.disconnect();
            setTimeout(function () { if (!this.touched) this.setApart(1); }.bind(this), 350);
          }.bind(this), { threshold: 0.5 });
          io.observe(this.stage);
        } else this.setApart(1);
      }
      this.keys.forEach(function (b) {
        var l = +b.dataset.l;
        b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') this.setLift(l); }.bind(this));
        b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') this.setLift(this.pinned); }.bind(this));
        b.addEventListener('click', function () { this.pinned = this.pinned === l ? 0 : l; this.setLift(this.pinned); }.bind(this));
      }, this);
      this.stage.addEventListener('pointerdown', this.onDown.bind(this));
      this.stage.addEventListener('pointermove', this.onMove.bind(this));
      this.stage.addEventListener('pointerup', this.onUp.bind(this));
      this.stage.addEventListener('pointercancel', this.onUp.bind(this));
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.fit.bind(this));
        this.ro.observe(this.stage);
      } else {
        window.addEventListener('resize', this.fit.bind(this));
      }
      this.fit();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    fit() {
      var k = Math.min(1.25, this.stage.clientWidth / SIDE);
      if (k > 0) this.stack.style.setProperty('--szw-hm-k', k.toFixed(3));
    }

    turn() {
      this.stack.style.setProperty('--szw-hm-rx', this.rx.toFixed(1));
      this.stack.style.setProperty('--szw-hm-rz', this.rz.toFixed(1));
    }

    setLift(l) {
      this.slabs.forEach(function (s) { s.classList.toggle('is-lifted', +s.dataset.l === l); });
      this.keys.forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.l === this.pinned ? 'true' : 'false'); }, this);
    }

    setApart(v) {
      this.stack.style.setProperty('--szw-hm-apart', v.toFixed(2));
      if (this.range) {
        this.range.value = Math.round(v * 100);
        this.range.setAttribute('aria-valuetext', v < 0.05 ? 'Closed' : v > 0.95 ? 'Open' : Math.round(v * 100) + '% open');
        this.range.style.setProperty('--szw-hm-fill', Math.round(v * 100) + '%');
      }
    }

    onRange() {
      this.touched = true;
      this.stack.classList.add('is-sliding');   // follow the finger, no easing lag
      this.setApart(this.range.value / 100);
    }

    onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      this.drag = [e.clientX, e.clientY, this.rx, this.rz];
      try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
    }

    onMove(e) {
      if (!this.drag) return;
      this.rz = this.drag[3] + (e.clientX - this.drag[0]) * 0.4;
      this.rx = Math.max(20, Math.min(75, this.drag[2] - (e.clientY - this.drag[1]) * 0.3));
      this.turn();
    }

    onUp() {
      this.drag = null;
    }
  }

  customElements.define('szw-howmade', SzwHowmade);
})();
